import { reverse } from "@reactivated";

import { IAddress } from "../models/address";
import { IShippingMethod, ShippingMethods } from "../models/shipping";
import { check } from "../models/utils";
import { CSRF_HEADER, fetchJson, getCSRFToken } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

export const loadMethods = async (
    shipping_address: Partial<IAddress>,
): Promise<ReadonlyArray<IShippingMethod>> => {
    const params = new URLSearchParams();
    if (shipping_address.line1) params.append("line1", shipping_address.line1);
    if (shipping_address.line2) params.append("line2", shipping_address.line2);
    if (shipping_address.line4) params.append("line4", shipping_address.line4);
    if (shipping_address.state) params.append("state", shipping_address.state);
    if (shipping_address.postcode)
        params.append("postcode", shipping_address.postcode);
    if (shipping_address.country)
        params.append("country", shipping_address.country);

    const mutex = new PromiseMutex<ReadonlyArray<IShippingMethod>>(
        `load-shipping-methods-${shipping_address.country}-${shipping_address.state}`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = fetchJson(
            `${reverse("checkout-shipping-methods")}?${params}`,
        ).then((body) => {
            return check(ShippingMethods.decode(body));
        });
        mutex.setPromise(loading);
    }
    return loading;
};

export const saveShippingMethod = async (
    shipping_address: Partial<IAddress>,
    methodCode: string,
): Promise<ReadonlyArray<IShippingMethod>> => {
    const data = {
        line1: shipping_address.line1 || "",
        line2: shipping_address.line2 || "",
        line4: shipping_address.line4 || "",
        state: shipping_address.state || "",
        postcode: shipping_address.postcode || "",
        country: shipping_address.country || "",
        shipping_method_code: methodCode,
    };
    const body = await fetchJson(reverse("checkout-shipping-methods"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            [CSRF_HEADER]: await getCSRFToken(),
        },
        body: JSON.stringify(data),
    });
    return check(ShippingMethods.decode(body));
};
